module.exports = "/_next/static/images/d580a931e76bd05fce86ee22810cc012-nubanker-ds@3x.jpg";